import img13 from './Rehabilitacion/img13.jpg'
import img14 from './Rehabilitacion/img14.jpg'
import img15 from './Rehabilitacion/img15.jpg'
import img16 from './Rehabilitacion/img16.jpg'
import img17 from './Rehabilitacion/img17.jpg'
import img18 from './Rehabilitacion/img18.jpg'
import img19 from './Rehabilitacion/img19.jpg'
import img20 from './Rehabilitacion/img20.jpg'
import img21 from './Rehabilitacion/img21.jpg'
import img22 from './Rehabilitacion/img22.jpg'
import img23 from './Rehabilitacion/img23.jpg'
import img24 from './Rehabilitacion/img24.jpg'
import { Footer } from './Footer'
import React, { Component } from 'react'
import { Card, Pagination, Row, Col, Container } from 'react-bootstrap'
import { Navigation } from './Navigation'

export class Rehabilitacion2 extends Component {
    render() {
        // Mantenemos el arreglo de las 12 imágenes
        const imagenes = [
            img13, img14, img15, img16, img17, img18, 
            img19, img20, img21, img22, img23, img24
        ];

        return (
            <div>
                <Navigation />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1>Rehabilitación</h1>
                        </Col>
                    </Row>
                    <br />

                    <Pagination className="justify-content-center" size="lg">
                        <Pagination.Item href="/rehabilitacion">{1}</Pagination.Item>
                        <Pagination.Item active>{2}</Pagination.Item>
                        <Pagination.Item href="/rehabilitacion3">{3}</Pagination.Item>
                    </Pagination>
                    <br />

                    {/* Configuración de 2 columnas para máximo detalle técnico */}
                    <Row xs={1} md={2} lg={2} className="g-5 text-center">
                        {imagenes.map((img, idx) => (
                            <Col key={idx}>
                                <Card className="h-100 shadow border-0">
                                    <Card.Body className="p-2">
                                        <Card.Img 
                                            variant="top" 
                                            src={img} 
                                            style={{ 
                                                height: '550px', 
                                                objectFit: 'contain',
                                                width: '100%'
                                            }} 
                                        />
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>

                    <br />
                    <Pagination className="justify-content-center mt-5" size="lg">
                        <Pagination.Item href="/rehabilitacion">{1}</Pagination.Item>
                        <Pagination.Item active>{2}</Pagination.Item>
                        <Pagination.Item href="/rehabilitacion3">{3}</Pagination.Item>
                    </Pagination>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}